(function () {
    'use strict';

    angular.module('smartpublic.utils').directive('dropZone', Dropzone);

    Dropzone.$inject = [];

    function Dropzone() {
        var config = {

            template: '<label class="drop-zone" id="dropZoneUpload">' +
            '<input type="file" multiple  />' +
            '<div ng-transclude class="realDrop"></div>' +       // <= transcluded stuff
            '</label>',

            transclude: true,
            replace: true,
            require: '?ngModel',
            link: function (scope, element, attributes, ngModel) {
                var upload = element[0].querySelector('input');
                upload.addEventListener('dragover', uploadDragOver, false);
                upload.addEventListener('drop', uploadFileSelect, false);
                upload.addEventListener('change', uploadFileSelect, false);
                config.scope = scope;
                config.model = ngModel;
            }
        };
        return config;


        // Helper functions
        function uploadDragOver(e) {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        }


        function fileExtensionAllowed(filename) {

            var allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];
            var extension = filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);

            return (allowedExtensions.indexOf(extension.toLowerCase()) !== -1);

        }


        function uploadFileSelect(e) {
            //console.log(this);
            e.stopPropagation();
            e.preventDefault();
            var files = e.dataTransfer ? e.dataTransfer.files : e.target.files;

            for (var i = 0, file; file = files[i]; ++i) {
                //console.log(file);

                if (fileExtensionAllowed(file.name)) {
                    var reader = new FileReader();

                    reader.onload = (function (file) {
                        return function (e) {

                            // Data handling (just a basic example):
                            // [object File] produces an empty object on the model
                            // why we copy the properties to an object containing
                            // the Filereader base64 data from e.target.result
                            var data = {
                                data: e.target.result,
                                dataSize: e.target.result.length
                            };
                            for (var p in file) {
                                data[p] = file[p];
                            }
                            if (data.dataSize > 5) {
                                // in case of empty files the length would be 5 because data="data:"
                                // empty files will be excluded
                                config.scope.$apply(function () {
                                    config.model.$viewValue.push(data);
                                });
                            }
                        };
                    })(file);
                    reader.readAsDataURL(file);
                }

            }
        }
    }

})
();
